import type { CalendarEvent } from './icsCalendar'
import { eventOccursOnCalendarDay, isMultiDayCalendarEvent } from './icsCalendar'

/** Po–Ne: index 0 = pondělí (jako v CalendarView). */
export function getMonthGridMeta(year: number, month: number) {
  const firstDayOfMonth = new Date(year, month, 1).getDay()
  const daysInMonth = new Date(year, month + 1, 0).getDate()
  const adjustedFirstDay = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1
  return { daysInMonth, adjustedFirstDay }
}

export function isMultiDayEvent(event: CalendarEvent): boolean {
  return isMultiDayCalendarEvent(event)
}

export function getEventsForDayInMonth(
  events: CalendarEvent[],
  year: number,
  month: number,
  day: number
): CalendarEvent[] {
  return events.filter((event) => eventOccursOnCalendarDay(event, year, month, day))
}

export const MONTH_NAMES_CZ = [
  'Leden',
  'Únor',
  'Březen',
  'Duben',
  'Květen',
  'Červen',
  'Červenec',
  'Srpen',
  'Září',
  'Říjen',
  'Listopad',
  'Prosinec',
] as const

export const DAY_NAMES_CZ_SHORT = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'] as const
